module.exports = __webpack_public_path__ + "static/media/예봉산운길산.b2823232.jpg";